import { iconsDetailsProyectMenu } from "../../../../assets/icons/detailsProjectMenu";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { InmersysRoot, ProjectRoot } from "../../../../router/type_router";
import { statusProjectType } from "../../../../types/statusProject";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";
import { typesPauses } from "../../../../types/typePauses";
import { clipboard } from "../../../../helpers/clipboard";
import { fixSubtasks } from "../../../../config";


const getItemMenu = ({ project, actionModal, auth, getProjectDetails }) => {
    const { clickupSpace, name, hasSubstasks } = project
    const { isSuperAdmin, isAdmin } = auth

    const urls = {
        proyeccion: `${InmersysRoot.root}/${InmersysRoot.project}/${ProjectRoot.proyeccion}?project=${clickupSpace}&name=${name}`,
        simulation: `${InmersysRoot.root}/${InmersysRoot.project}/${ProjectRoot.simulation}?project=${clickupSpace}&name=${name}`,
    };

    const buttonsNormal = {
        shareProject: {
            text: "Compartir",
            img: iconsDetailsProyectMenu.compartir,
            action: async () => await clipboard(document.URL),
        },
        viewsimulation: {
            text: "Simulación",
            img: iconsDetailsProyectMenu.simulacion,
            action: () => window.open(urls.simulation, "_blank"),
        },
        scrum: {
            text: "Proyección",
            img: iconsDetailsProyectMenu.proyeccion,
            action: () => window.open(urls.proyeccion, "_blank"),
        },
    };

    if (hasSubstasks) {
        buttonsNormal.subtasks = {
            text: "Corregir subtareas",
            img: iconsDetailsProyectMenu.task,
            action: async () => {
                MessageAnt(MessageType.loading, "Espere mientras se revisan las subtareas");
                try {
                    const { payload: { fixed = [] } } = await fixSubtasks(clickupSpace);
                    if (fixed.length === 0) return MessageAnt(MessageType.warning, "No hubo correcciones de tareas. Revisa ClickUp.");
                    await getProjectDetails(clickupSpace)
                    return MessageAnt(MessageType.success, `Se corrigieron ${fixed.length} subtareas.`);
                } catch (error) {
                    return MessageAnt(MessageType.error, `Error al corregir subtareas.`);
                }

            }

        };
    }

    const cancelButtons = {
        cancel: {
            text: "Cancelar proyecto",
            img: iconsDetailsProyectMenu.cancelar,
            action: () => actionModal(typeForDetailsProyect.cancelarProyect, { selectProject: clickupSpace }),
        },
        continueCancel: {
            text: "Terminar de cancelar proyecto",
            img: iconsDetailsProyectMenu.continueCancelar,
            action: () => {
                actionModal(typeForDetailsProyect.continueCancelarProyect, { title: "Cancelar proyecto" });
            },
        },
        viewCommentCancel: {
            text: "Comentarios cancelar",
            img: iconsDetailsProyectMenu.comentariocancelar,
            action: () => actionModal(typeForDetailsProyect.viewConcluedProject),
        },
    };

    const pausesButtons = {
        pause: {
            text: `Pausar proyecto`,
            img: iconsDetailsProyectMenu.pause,
            action: () => actionModal(typeForDetailsProyect.pauses, { type: typesPauses.createPause }),
        },
        reactivepause: {
            text: `Reactivar Proyecto`,
            img: iconsDetailsProyectMenu.reanudar,
            action: () =>
                actionModal(typeForDetailsProyect.pauses, {
                    type: typesPauses.reactivePause,
                    isNecesaryModal: false,
                    title: "Reactivar proyecto",
                }),
        },
    };

    const concluidButtons = {
        conclude: {
            text: "Concluir proyecto",
            img: iconsDetailsProyectMenu.completarProyecto,
            action: () => actionModal(typeForDetailsProyect.finishProjectDate),
        },
        finishconclued: {
            text: `Terminar de concluir`,
            img: iconsDetailsProyectMenu.terminarCompletar,
            action: () => actionModal(typeForDetailsProyect.concluedProject),
        },
        finishred: {
            text: `Terminar de concluir`,
            img: iconsDetailsProyectMenu.terminarCompletar,
            action: () => actionModal(typeForDetailsProyect.concluedProject),
        },
        viewcomment: {
            text: "Ver comentarios",
            img: iconsDetailsProyectMenu.comentarioCompleto,
            action: () => actionModal(typeForDetailsProyect.concluedProject, { disableIputs: !(isAdmin || isSuperAdmin) }),
        },
    };

    const extraButtons = {
        updatetime: {
            text: "Actualizar tiempos",
            img: iconsDetailsProyectMenu.cancelar,
            action: () => actionModal(typeForDetailsProyect.updateTimeConclued),
        },
    };

    return {
        buttonsNormal,
        cancelButtons,
        pausesButtons,
        concluidButtons,
        extraButtons
    }
}

const filterByStatus = ({ itemsMenu, project }) => {
    const {
        hasRetrospective,
        isProjectRed,
        hasOverTime,
        hasCommentCancel,
        status
    } = project

    const {
        buttonsNormal,
        cancelButtons,
        pausesButtons,
        concluidButtons,
        // extraButtons
    } = itemsMenu

    const statusHandlers = {
        [statusProjectType.active]: () => ({
            ...buttonsNormal,
            pause: pausesButtons.pause,
            conclude: concluidButtons.conclude,
            cancel: cancelButtons.cancel
        }),
        [statusProjectType.pause]: () => ({
            ...buttonsNormal,
            reactivepause: pausesButtons.reactivepause
        }),
        [statusProjectType.concluid]: () => {
            let selection = project.isDeleted ? { ...buttonsNormal } : { ...buttonsNormal };;
            if (!hasRetrospective) selection.conclued = concluidButtons.finishconclued;
            else if (isProjectRed && !hasOverTime) selection.conclued = concluidButtons.viewcomment;
            else selection.viewcomment = concluidButtons.viewcomment;
            return selection;
        },
        [statusProjectType.cancel]: () => {
            let selection = { ...buttonsNormal };
            if (!hasCommentCancel) selection.cancelAccion = cancelButtons.continueCancel;
            else if (!hasRetrospective) selection.cancelAccion = concluidButtons.finishconclued;
            else if (!hasOverTime) selection.cancelAccion = concluidButtons.viewcomment;
            else selection.cancelAccion = cancelButtons.viewCommentCancel;
            return selection;
        },
    };
    return statusHandlers[status] ? statusHandlers[status]() : {}
}

const filterByAuth = ({ menuSelect, auth }) => {
    const { isAdmin, isSuperAdmin, isUser, isViewer } = auth

    const items = [];
    for (const key in menuSelect) {
        if (Object.hasOwnProperty.call(menuSelect, key)) {
            const element = menuSelect[key];
            if (isSuperAdmin) items.push(element);
            if (isAdmin && !["updatetime"].includes(key)) items.push(element);
            if (isUser && (["scrum", "shareProject", "viewcomment"].includes(key))) items.push(element);
            if (isViewer && (["scrum", "shareProject", "viewcomment"].includes(key))) items.push(element);
        }
    }
    return items.reverse();
}

export const getItemMenuProjectFiche = ({ project, actionModal, auth, getProjectDetails }) => {
    const itemsMenu = getItemMenu({ project, actionModal, auth, getProjectDetails });
    const menuSelect = filterByStatus({ itemsMenu, project });

    return filterByAuth({ auth, menuSelect });
}